import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../../../services/auth/auth.service';
import { Router } from '@angular/router';
import { AppStateService } from '../../../../services/appState/app-state.service';
// import {} from '../../../../../assets/img/avatars/8.jpg'

@Component({
  selector: 'glm-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
})
export class ProfileComponent implements OnInit {
  constructor(
    private serviceAuth: AuthService,
    private router: Router,
    private appState: AppStateService,
  ) {}

  @Input() name = 'John Doe';
  @Input() url = '../../../../../assets/img/profile/user_icon.png';

  ngOnInit(): void {}

  logout() {
    this.serviceAuth.logOutUser();
    this.appState.changeMessage('default');
    this.router.navigateByUrl('/login');
  }
}
